import { getContext, call, put } from 'redux-saga/effects';
import { isApiError, requestPuppy } from '@wix/da-http-client';
import { damzOffline, damzOnline } from '../actions/initialization';
function* initOrFetchSession(client) {
    // are they already loggedin?
    const userRes = yield client.auth.getUser();
    if (!userRes.error) {
        yield put(damzOnline());
        return;
    }
    // No auth, try and fetch it
    const result = yield call(requestPuppy, {
        method: 'get',
        url: `/session`
    }, undefined, 'damz');
    if (!result || isApiError(result) || !result.supaSession) {
        yield put(damzOffline('Failed to connect to message network'));
        return;
    }
    try {
        const session = JSON.parse(result.supaSession);
        const authRes = yield client.auth.setSession(session);
        if (authRes.error) {
            yield put(damzOffline('Failed to connect to message network'));
            return;
        }
        yield put(damzOnline());
    } catch (e) {
        yield put(damzOffline('Failed to connect to message network'));
    }
}
/**
 * Responsible for setting up the supabase session, SSR will create the
 * session once and then the client should be able to refresh forever after
 * that, the fallback is the to call the sesson endpoint if refresh et fails.
 */ export function* authSaga() {
    const client = yield getContext('supaClient');
    const damzConfig = yield getContext('damzConfig');
    // We have auth from server SSR, just set the session
    if (damzConfig.authSession) {
        try {
            const session = JSON.parse(damzConfig.authSession);
            const authRes = yield client.auth.setSession(session);
            if (authRes.error) {
                yield call(initOrFetchSession, client);
                return;
            }
            yield put(damzOnline());
        } catch (e) {
            yield call(initOrFetchSession, client);
        }
    } else {
        yield call(initOrFetchSession, client);
    }
}

//# sourceMappingURL=auth.js.map